import React from 'react';

class MPromoTwITFComp extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        require('../../common/mweb/css/index.css');
    }

    render() {
        const {t} = this.props;

        return (
            <div className="park-wrap park-promo promo-twitf">
                <header>
                    <div className="head-wrap" style={{position: 'relative'}}>
                        <h1 className="logo">
                            <img src="https://asset.981park.com/www/common/mweb/img/common/logo/981-park.svg" alt="981 PARK"/>
                        </h1>
                        <span className="typo1" style={{position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', color: 'white', fontSize: '16px', cursor: 'pointer'}}
                            onClick={() => { window.location.href = '/promoijto'; }}>中文</span>
                    </div>
                </header>
                <div className="content-wrap">
                    <div className="visual-wrap">
                        <div className="video">
                            <video autoPlay muted loop playsInline
                                   src="https://asset.981park.com/www/common/mweb/img/promo/mweb-promo-video.mp4"
                                   onLoadStart={() => {
                                       this.setState({mp4Loading: true});
                                   }}
                                   onLoadedData={() => {
                                       this.setState({mp4Loading: false});
                                   }}
                            ></video>
                        </div>
                        <div className="inner">
                            <div className="con">
                                <div className="text-wrap color1">
                                    <p className="m-text typo1">
                                        JEJU <br/>
                                        NO. 1 ATTRACTION, <br/>
                                        9.81 PARK
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="detail-con-wrap">
                        <div className="inner">
                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>
                            
                            {/* Ticket Section */}
                            <div className="section-ticket">
                                <div className="section-title">
                                    <h2>Start your race here!<br/>- get your ticket online</h2>
                                </div>
                                <div className="ticket-cards">
                                    <a href="https://www.klook.com/activity/86261-981-park-ticket-jeju/" className="ticket-card" target="_blank" rel="noopener noreferrer">
                                        <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-ticket-klook-card.png" alt="Klook Ticket" />
                                    </a>
                                    <a href="https://us.trip.com/travel-guide/attraction/Jeju/9.81%20Park%20Jeju-133524981/" className="ticket-card" target="_blank" rel="noopener noreferrer">
                                        <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-ticket-trip.com-card.png" alt="Trip.com Ticket" />
                                    </a>
                                    <a href="https://www.kkday.com/en/product/131733-9-81-park-jeju-ticket-jeju-island-south-korea" className="ticket-card" target="_blank" rel="noopener noreferrer">
                                        <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-ticket-kkday-card.png" alt="KKDay Ticket" />
                                    </a>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Review Section */}
                            <div className="section-review">
                                <div className="section-title">
                                    <h2>Korea's only technology-based,<br/>cutting-edge theme park</h2>
                                </div>
                                <div className="review-image">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-review-img.png" alt="Indoor Display" />
                                </div>
                                <div className="review-cards">
                                    <div className="review-card card-klook">
                                        <div className="review-header">
                                            <div className="profile">
                                                <div className="profile-img"></div>
                                                <div className="profile-info">
                                                    <p className="name">Laura *</p>
                                                    <div className="stars"></div>
                                                </div>
                                            </div>
                                            <div className="platform-logo">
                                            <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-review-klook-logo.png" alt="Klook" />
                                        </div>
                                        </div>
                                        <div className="review-text">
                                            <p>System was efficient and high tech. Would recommend downloading the app beforehand and arriving on time for the gokart race courses as it takes roughly 1hr to complete all 3 tracks. First track takes video from the front angle so be prepared for it, the subsequent two tracks took videos from the rear angles. Usually the footages will be shared to your account within the app itself, quite impressive.</p>
                                        </div>
                                    </div>

                                    <div className="review-card card-trip">
                                        <div className="review-header">
                                            <div className="profile">
                                                <div className="profile-img"></div>
                                                <div className="profile-info">
                                                    <p className="name">TIHK***vv6dw</p>
                                                    <div className="stars"></div>
                                                </div>
                                            </div>
                                            <div className="platform-logo">
                                            <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-review-trip.com-logo.png" alt="Trip.com" />
                                        </div>
                                        </div>
                                        <div className="review-text">
                                            <p>Very easy, go to the direct change of hand belt, the park has shuttle bus, details can be viewed on the official website, call taxis are not difficult to leave. Before you go, remember to download 9.81 apps you can pick up the items to play and not play. If you encounter weather problems, you can't play some projects. Remember to go to the counter to apply for a refund. The rain karting and 360 degrees are not open. There is a cafe in the park and a snack shop.</p>
                                        </div>
                                    </div>

                                    <div className="review-card card-google">
                                        <div className="review-header">
                                            <div className="profile">
                                                <div className="profile-img"></div>
                                                <div className="profile-info">
                                                    <p className="name">Terry Bl**</p>
                                                    <div className="stars"></div>
                                                </div>
                                            </div>
                                            <div className="platform-logo">
                                            <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-review-google-logo.png" alt="Google" />
                                        </div>
                                        </div>
                                        <div className="review-text">
                                            <p>Really a unique place with great technology! With a lot of amazing new games that could spent 3 hour up here, well deserved a visit for all visitors! Highly recommended place.</p>
                                        </div>
                                    </div>

                                    <div className="review-card card-kkday">
                                        <div className="review-header">
                                            <div className="profile">
                                                <div className="profile-img"></div>
                                                <div className="profile-info">
                                                    <p className="name">Rom**n</p>
                                                    <div className="stars"></div>
                                                </div>
                                            </div>
                                            <div className="platform-logo">
                                            <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-review-kkday-logo.png" alt="KKDay" />
                                        </div>
                                        </div>
                                        <div className="review-text">
                                            <p>Incredible experience. The use of the application on your phone to get the stats and the video of your race immediately after you get out of the vehicle is an amazing idea. Even the Ringo car game with "ghost" players is really well done when you don't have enough real players. The staff was really friendly with us and took their time to help us be comfortable. It was really an amazing experience that I recommend to everyone.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Activity Section */}
                            <div className="section-activity">
                                <div className="section-title">
                                    <h2>So many things to enjoy<br/>that time flew by!</h2>
                                </div>
                                <div className="section-image">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-activity-img.png" alt="Activity" />
                                </div>
                                <div className="section-text">
                                    <p>This place is packed with a wide variety of activities.</p>
                                    <p>&nbsp;</p>
                                    <p>From the globally unique Gravity Racing to indoor survival games, futuristic bumper cars, a 360-degree rotating swing, AR and VR arcade games, you should plan to spend at least 4 to 5 hours here.</p>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Tech Section */}
                            <div className="section-tech">
                                <div className="section-title">
                                    <h2>It's an amazing technology unlike<br/>anything you've seen before!</h2>
                                </div>
                                <div className="section-image">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-tech-img.png" alt="Technology" />
                                </div>
                                <div className="section-text">
                                    <p>Race 981, offering courses of various difficulties, combines multiple technologies including IoT and GPS to provide real-time data such as lap times, lateral G-forces, and ranking for racers.</p>
                                    <p>&nbsp;</p>
                                    <p>Additionally, GoPro videos installed in various locations are edited in real-time and provided through an app.</p>
                                    <p>&nbsp;</p>
                                    <p>This state-of-the-art theme park introduces unprecedented smart technologies from Korea, giving visitors a sensation of being in a futuristic world unlike anywhere else in the world.</p>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* View Section */}
                            <div className="section-view">
                                <div className="section-title">
                                    <h2>The ocean view is absolutely<br/>stunning!</h2>
                                </div>
                                <div className="section-image">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-view-img.png" alt="Ocean View" />
                                </div>
                                <div className="section-text">
                                    <p>Located where you can see the Baekrokdam of Hallasan above and the front sea of Jeju Island below,</p>
                                    <p>&nbsp;</p>
                                    <p>9.81 Park offers enjoyable play and beautiful scenery, allowing visitors from both overseas and Korea to fully appreciate the stunning nature and landscapes of Jeju.</p>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Food Section */}
                            <div className="section-food">
                                <div className="section-title">
                                    <h2>It's delicious. They've captured<br/>Jeju's flavors beautifully in Korea.</h2>
                                </div>
                                <div className="section-image">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-food-img.png" alt="Food" />
                                </div>
                                <div className="section-text">
                                    <p>There are various restaurants and cafes where you can truly experience the flavors of Korea and Jeju Island.</p>
                                    <p>&nbsp;</p>
                                    <p>Try cafes serving fragrant coffee and tea along with dishes featuring famous Jeju black pork or cutlassfish. With numerous attractions to enjoy, you can satisfy your hunger at various restaurants here that offer everything you need.</p>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Payment Section */}
                            <div className="section-payment">
                                <div className="section-title">
                                    <h2>Easy and fast reservation and<br/>payment system.</h2>
                                </div>
                                <div className="payment-logos">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-klook-logo.png" alt="Klook" className="logo-klook" />
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-tripcom-logo.png" alt="Trip.com" className="logo-trip" />
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-kkday-logo.png" alt="KKDay" className="logo-kkday" />
                                </div>
                                <div className="section-text">
                                    <p>Through various partnerships, you can conveniently make reservations by selecting your visit date on your preferred channel</p>
                                    <p>&nbsp;</p>
                                    <p>and enjoy our services hassle-free.</p>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Shuttle Section */}
                            <div className="section-shuttle">
                                <div className="section-title">
                                    <h2>Conveniently located with<br />shuttle bus service.</h2>
                                </div>
                                <div className="shuttle-map">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-map-img.png" alt="Shuttle Map" />
                                </div>
                                <div className="section-text">
                                    <p>Located within approximately 30 minutes from major locations in Jeju Island</p>
                                </div>
                                <div className="location-list">
                                    <ul>
                                        <li>Jeju International Airport</li>
                                        <li>Jeju Dongmun Market</li>
                                        <li>Jeju International Airport</li>
                                        <li>Seonhsan ilchulbong</li>
                                        <li>Lotte Hotel Jeju</li>
                                        <li>Shilla Hotel</li>
                                        <li>Ramada Hotel</li>
                                        <li>Jeju Shinhwa World</li>
                                        <li>Grand Hyatt Jeju</li>
                                        <li>Maison Glad Jeju</li>
                                    </ul>
                                </div>
                                <div className="shuttle-locations">
                                    <div className="location-item">
                                        <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-shuttle-airport-img.png" alt="Airport Bus Stop" />
                                    </div>
                                    <div className="location-item">
                                        <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-shuttle-lotte-img.png" alt="Lotte Bus Stop" />
                                    </div>
                                </div>
                                <div className="shuttle-schedule">
                                    <h3>To 9.81 PARK</h3>
                                    
                                    <div className="schedule-table">
                                        <div className="schedule-row">
                                            <div className="schedule-label">Airport (3rd floor departure - Bus stop area) → Park</div>
                                            <div className="schedule-times">
                                                <span>10:00</span>
                                                <span>11:00</span>
                                                <span>13:30</span>
                                            </div>
                                        </div>
                                        <div className="schedule-row">
                                            <div className="schedule-label">LOTTE DUTY FREE → Park</div>
                                            <div className="schedule-times">
                                                <span>10:05</span>
                                                <span>11:05</span>
                                                <span>13:35</span>
                                            </div>
                                        </div>
                                    </div>
                                    <h3>From 9.81 PARK</h3>
                                    <div className="schedule-table">
                                        <div className="schedule-row">
                                            <div className="schedule-label">Park → Airport</div>
                                            <div className="schedule-times">
                                                <span>9:00</span>
                                                <span>10:00</span>
                                                <span>12:30</span>
                                                <span>16:30</span>
                                            </div>
                                        </div>
                                        <div className="schedule-row">
                                            <div className="schedule-label">Opposite of LOTTE DUTY FREE → Airport</div>
                                            <div className="schedule-times">
                                                <span>10:25</span>
                                                <span>12:55</span>
                                                <span>16:55</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Divider */}
                            <div className="divide-line">
                                <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/divide-line.svg" alt="" />
                            </div>

                            {/* Celebrity Section */}
                            <div className="section-celebrity">
                                <div className="section-title">
                                    <h2>981 with Famous<br/>Korean TV shows and Celebrities!</h2>
                                </div>
                                <div className="celebrity-image">
                                    <img src="https://asset.981park.com/www/common/mweb/img/promo/twitf/twitf-celeb-img.png" alt="Celebrity" />
                                </div>
                                <div className="tv-shows-list">
                                    <div className="tv-show-item">
                                        <h4>나 혼자 산다 (Home Alone)</h4>
                                        <a href="https://youtu.be/hBW0lulSxws?feature=shared" target="_blank" rel="noopener noreferrer">https://youtu.be/hBW0lulSxws?feature=shared</a>
                                    </div>
                                    <div className="tv-show-item">
                                        <h4>어서와 한국은 처음이지 (Yo~! Welcome To Korea!)</h4>
                                        <a href="https://youtu.be/1jJ0x4MHPLQ?feature=shared" target="_blank" rel="noopener noreferrer">https://youtu.be/1jJ0x4MHPLQ?feature=shared</a>
                                    </div>
                                    <div className="tv-show-item">
                                        <h4>스트릿 맨 파이터 (Street Man Fighter)</h4>
                                        <a href="https://youtu.be/ZYEjtxFcZvQ?feature=shared" target="_blank" rel="noopener noreferrer">https://youtu.be/ZYEjtxFcZvQ?feature=shared</a>
                                    </div>
                                    <div className="tv-show-item">
                                        <h4>환승연애 (Transferring Love)</h4>
                                        <a href="https://www.tving.com/contents/E003598936" target="_blank" rel="noopener noreferrer">https://www.tving.com/contents/E003598936</a>
                                    </div>
                                    <div className="tv-show-item">
                                        <h4>짠내투어 (More Salty Tour)</h4>
                                        <a href="https://youtu.be/EM_hWvyMPVg?feature=shared" target="_blank" rel="noopener noreferrer">https://youtu.be/EM_hWvyMPVg?feature=shared</a>
                                    </div>
                                    <div className="tv-show-item">
                                        <h4>나는 SOLO (I am SOLO)</h4>
                                        <a href="https://programs.sbs.co.kr/plus/loveforever/clip/74495/22000467108" target="_blank" rel="noopener noreferrer">https://programs.sbs.co.kr/plus/loveforever/clip/74495/22000467108</a>
                                    </div>
                                    <div className="tv-show-item">
                                        <h4>SSBD Travel</h4>
                                        <a href="https://youtu.be/WP622BeSAWU?feature=shared" target="_blank" rel="noopener noreferrer">https://youtu.be/WP622BeSAWU?feature=shared</a>
                                    </div>
                                </div>
                                <div className="celebrity-subtitle">
                                    <h3>Celebrity</h3>
                                </div>
                                <div className="celebrity-grid">
                                    <div className="celebrity-row">
                                        <span>HWASA</span>
                                        <span>KYUHYUN</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>NARAE PARK</span>
                                        <span>CHU SEONG HOON</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>HYUNMOO JEON</span>
                                        <span>DONG GOOK LEE</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>GIAN 84</span>
                                        <span>MINJONG KIM</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>FAKER</span>
                                        <span>SIEON LEE</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>SOOHYANG LIM</span>
                                        <span>HYEJIN HAN</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>MYUNGSOO PARK</span>
                                        <span>JUNHO KIM</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>JOY(RED VEVLET)</span>
                                        <span>MINSOO YUN</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>EHYUN SO</span>
                                        <span>SOHEE AN</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>SONIA CHEW</span>
                                        <span>ANN NICOLE</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>NUCKSAL</span>
                                        <span>NAMJOO(APINK)</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>DONGWOOK LEE</span>
                                        <span>MISUN PARK</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>SUNGCHAN(RIIZE)</span>
                                        <span>SHOTARO(RIIZE)</span>
                                    </div>
                                    <div className="celebrity-row">
                                        <span>JENNY PARK</span>
                                        <span>NAYOUNG KIM</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MPromoTwITFComp;